import { Button } from "react-bootstrap"
import { BiCart } from "react-icons/bi"
import Notiflix from 'notiflix'
import moment from "moment";
import PostApiCall from "../Helpers/PostAPI";
import { useContext, useState } from "react";
import { newstore } from "../OnlineOrdering/Home/Pages/Store/newStore";
import { NewLoginModal } from "../NewLoginModal";
const NewAddTocart = ({ itemid }) => {

	const { setcart, setCartItems } = useContext(newstore);
	const [isOpen, setIsOpen] = useState(false);
	const [modalSide, setModalSide] = useState("Log");

	const handleToggleModal = () => {
		setIsOpen(false);
		setModalSide("Log");
	};

	const handleChangeModalSide = (e) => {
		setModalSide(e);
	};

	const GetCartdetails = () => {
		var Order = localStorage.getItem("OrderData");
		var OrderData = JSON.parse(Order);
		// var orderid = 0;
		// if (localStorage.getItem("OrderData") !== null) {
		//     orderid = OrderData[0].order_id
		// }
		if (localStorage.getItem("CustomerData") === null) {
		} else {
			var login = localStorage.getItem("CustomerData");
			var logindetails = JSON.parse(login);
			if (localStorage.getItem("OrderData") !== null) {
				PostApiCall.postRequest(
					{
						orderid:
							!localStorage.getItem("OrderData")
								? null
								: OrderData[0].order_id,
						id:
							!localStorage.getItem("CustomerData")
								? null
								: logindetails[0].fld_customerid,
					},
					"GetCartWebsite"
				)
					.then((res) => res.json())
					.then((res1) => {
						if (res1.data) {
							setcart(res1.data.reduce((a, v) => (a = a + v.fld_quantity), 0));
							setCartItems(res1.data);
						}
					});
			}
		}
	};

	const addtocart = () => {
		Notiflix.Loading.Circle("");
		var login = localStorage.getItem("CustomerData");
		var logindetails = JSON.parse(login);
		var Order = localStorage.getItem("OrderData");
		var OrderData = JSON.parse(Order);
		if (logindetails === null) {
			localStorage.setItem(
				"itemdetails",
				JSON.stringify([
					{
						Item: `${itemid}`,
						Quantity: `${1}`,
					},
				])
			);
			setIsOpen(true) // open login modal
			Notiflix.Loading.Remove()
		} else {
			// ===========with Login=========
			PostApiCall.postRequest(
				{
					orderdate: moment().format("lll"),
					itemdetails: `
                 [
                 {
                     "Item":${itemid
						},
                     "Quantity":${1}
                 }
                 ]
                 `,
					status: "INCART",
					customerid: localStorage.getItem("CustomerData") == null ? null : logindetails[0].fld_customerid,
					createdon: moment().format("lll"),
					updatedon: moment().format("lll"),
					orderid: localStorage.getItem("OrderData") == null ? 0 : OrderData[0].order_id,
					updatedby: localStorage.getItem("CustomerData") == null ? null : logindetails[0].fld_userid,
				},
				"AddToCartWebsite"
			).then((result) =>
				result.json().then((obj) => {
					if (result.status === 200 || result.status === 201) {
						// Notiflix.Loading.Remove();
						if (localStorage.getItem("OrderData") == null) {
							localStorage.setItem("OrderData", JSON.stringify(obj.data));
							GetCartdetails();
							Notiflix.Notify.Success("Product added to Cart.");
							Notiflix.Loading.Remove()
						} else {
							GetCartdetails();
							Notiflix.Notify.Success("Product added to Cart.");
							Notiflix.Loading.Remove()
						}
					} else {
						Notiflix.Loading.Remove();
						Notiflix.Notify.Failure(obj.data);
					}
				})
			);
		}
	}

	return (
		<>
			<NewLoginModal
				isOpen={isOpen}
				handleToggleModal={handleToggleModal}
				modalSide={modalSide}
				handleChangeModalSide={handleChangeModalSide}
			/>
			<button
				className="border-0 d-flex align-items-center rounded"
				style={{
					lineHeight: 1,
					padding: "0.5rem 1rem",
					backgroundColor: "#fbf503"
				}}
				onClick={addtocart}
			>
				Add
			</button>

			<NewLoginModal />
		</>
	)
}

export default NewAddTocart